import { FiEye } from 'react-icons/fi'

const TEMPLATES = [
  {
    id: 'minimal-corporate',
    name: 'Minimal Corporate',
    description: 'Clean, professional design perfect for business cards',
    preview: '🏢',
    category: 'business',
    features: ['Logo placement', 'Contact info', 'Professional layout']
  },
  {
    id: 'modern-creative',
    name: 'Modern Creative',
    description: 'Contemporary design with creative elements and branding',
    preview: '🎨',
    category: 'business',
    features: ['Creative layout', 'Brand colors', 'Modern typography']
  },
  {
    id: 'id-style',
    name: 'ID Style Card',
    description: 'Employee ID card format with photo and company branding',
    preview: '🪪',
    category: 'employee',
    features: ['Profile photo', 'Employee details', 'Company branding']
  }
]

export default function CardTemplates() {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Card Templates</h3>
          <p className="text-sm text-gray-600">Choose from professionally designed templates</p>
        </div>
        <button className="btn-secondary flex items-center gap-2">
          <FiEye className="w-4 h-4" />
          View All Templates
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {TEMPLATES.map(template => (
          <div key={template.id} className="border border-gray-200 rounded-lg p-4 hover:border-blue-300 transition-colors">
            {/* Template Preview */}
            <div className="aspect-[3.5/2] bg-gradient-to-br from-blue-50 to-indigo-100 rounded-lg mb-4 flex items-center justify-center">
              <div className="text-center">
                <div className="text-4xl mb-2">{template.preview}</div>
                <div className="text-xs text-gray-500 uppercase tracking-wide">
                  {template.category}
                </div>
              </div>
            </div>

            {/* Template Info */}
            <div className="space-y-2">
              <h4 className="font-semibold text-gray-900">{template.name}</h4>
              <p className="text-sm text-gray-600">{template.description}</p>

              {/* Features */}
              <div className="space-y-1">
                {template.features.map((feature, index) => (
                  <div key={index} className="flex items-center text-xs text-gray-500">
                    <span className="w-1 h-1 bg-gray-400 rounded-full mr-2"></span>
                    {feature}
                  </div>
                ))}
              </div>
            </div>

            {/* Template Actions */}
            <div className="mt-4 pt-4 border-t border-gray-100">
              <button className="w-full btn-secondary text-sm">
                Use This Template
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Template Features */}
      <div className="mt-8 bg-blue-50 rounded-lg p-4">
        <h4 className="font-semibold text-blue-900 mb-2">Template Features</h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-blue-800">
          <div className="flex items-center">
            <span className="text-blue-600 mr-2">✓</span>
            Print-ready designs
          </div>
          <div className="flex items-center">
            <span className="text-blue-600 mr-2">✓</span>
            Responsive layouts
          </div>
          <div className="flex items-center">
            <span className="text-blue-600 mr-2">✓</span>
            Customizable colors
          </div>
          <div className="flex items-center">
            <span className="text-blue-600 mr-2">✓</span>
            High-resolution export
          </div>
          <div className="flex items-center">
            <span className="text-blue-600 mr-2">✓</span>
            Professional typography
          </div>
          <div className="flex items-center">
            <span className="text-blue-600 mr-2">✓</span>
            Brand consistency
          </div>
        </div>
      </div>
    </div>
  )
}